import axios from "axios";

import {
  HttpClient,
  HttpRequest,
  HttpResponse,
} from "../../data/protocols/http";

export class AxiosHttpClient implements HttpClient {
  async request(data: HttpRequest): Promise<HttpResponse<HttpResponse>> {
    try {
      if (data.method === "get") {
        const axiosResponse = await axios.get(data.url, {
          headers: data.headers,
          withCredentials: data.withCreadentials,
          params: data.params,
        });
        return {
          statusCode: axiosResponse.status,
          body: axiosResponse.data,
        };
      }
      const axiosResponse = await axios.request({
        url: data.url,
        headers: data.headers,
        data: data.body,
        method: data.method,
        params: data.params,
        withCredentials: data.withCreadentials,
      });
      return {
        statusCode: axiosResponse.status,
        body: axiosResponse.data,
      };
    } catch (error: any) {
      return error.response
        ? {
            statusCode: error.response.status,
            body: error.response.data,
          }
        : { statusCode: 500, body: null };
    }
  }
}
